export default __webpack_public_path__ + "home-logo.5d304a77.png";